import { create } from "zustand";
import type { UserRole } from "@/types";

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  token: string | null;
  userRole: UserRole;
  username: string | null;
  email: string | null;

  setAuth: (data: {
    isAuthenticated: boolean;
    token: string | null;
    userRole: UserRole;
    username: string | null;
    email: string | null;
  }) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  isLoading: true,
  token: null,
  userRole: "anonymous",
  username: null,
  email: null,

  setAuth: (data) =>
    set({
      isAuthenticated: data.isAuthenticated,
      token: data.token,
      userRole: data.userRole,
      username: data.username,
      email: data.email,
      isLoading: false,
    }),

  setLoading: (loading) => set({ isLoading: loading }),

  clearAuth: () =>
    set({
      isAuthenticated: false,
      token: null,
      userRole: "anonymous",
      username: null,
      email: null,
      isLoading: false,
    }),
}));